export const exampleCounties = {
  'california.us': 'san-mateo-county.ca.us',
  'delaware.us': 'sussex-county.de.us',
  'louisiana.us': 'jefferson-parish.la.us',
  'mississippi.us': 'jackson-county.ms.us',
  'new-hampshire.us': 'rockingham-county.nh.us',
  'new-jersey.us': 'ocean-county.nj.us',
  'new-york.us': 'nassau-county.ny.us',
  'north-carolina.us': 'dare-county.nc.us',
  'maine.us': 'york-county.me.us',
  'maryland.us': 'worcester-county.md.us',
  'massachusetts.us': 'suffolk-county.ma.us',
  'oregon.us': 'clatsop-county.or.us',
  'rhode-island.us': 'bristol-county.ri.us',
  'south-carolina.us': 'charleston-county.sc.us',
  'texas.us': 'jefferson-county.tx.us',
  'virginia.us': 'virginia-beach-city.va.us',
  'washington.us': 'cowlitz-county.wa.us',
}; 
